import OtpInput from '../OtpInput';
import { getConfig, translate } from '@micro-apps/env';
import Cta from '../../Cta';
import { useState } from 'react';
import Checkbox from '../../Checkbox';

const { RESERVATIONS_SITE_URL } = getConfig(process.env);

export default function SubmitOtpForm({
	sendCodeVia,
	sendCodeTo,
	isError,
	resetFlow,
	handleSubmit,
	locale,
}) {
	const [OTP, setOTP] = useState('');
	const [isDetailsOpen, setIsDetailsOpen] = useState(false);
	const [persistLogin, setPersistLogin] = useState(false);

	return (
		<div className="submit-otp otp-sign-in">
			{!isError ? (
				<>
					<h1 className="heading-2">{translate('Verification Code')}</h1>
					<p
						className="intro body-2"
						dangerouslySetInnerHTML={{
							__html: translate(
								`An ${
									sendCodeVia === 'EMAIL_ADDRESS' ? 'email' : 'SMS'
								} with a 6-digit code was sent to <strong>{0}</strong>. Please enter the code in the fields shown. If you did not receive a verification code, you may need to <a href='{1}' ui-sref='{2}'>register.</a>`,
								[
									sendCodeTo,
									`${RESERVATIONS_SITE_URL}${locale !== 'en' ? '/' + locale : ''}/register`,
									'register_2018',
								]
							),
						}}
					/>

					<form noValidate autoComplete="off">
						<OtpInput onChange={e => setOTP(e)} />
						<div className="remember-me">
							<Checkbox onChange={() => setPersistLogin(!persistLogin)} />{' '}
							<span className="body-2">{translate('Keep me signed in')}</span>
							<span className="details" onClick={() => setIsDetailsOpen(!isDetailsOpen)}>
								{translate('Details')}
								{isDetailsOpen ? (
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="14"
										height="15"
										viewBox="0 0 14 15"
										fill="none"
									>
										<path
											d="M2.88584 10.5L1.5 10.497L7.0059 5.5L12.5 10.497H11.1302L2.88584 10.5Z"
											fill="#4D4D4D"
										/>
									</svg>
								) : (
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="14"
										height="15"
										viewBox="0 0 14 15"
										fill="none"
									>
										<path
											d="M2.88584 5.5L1.5 5.50302L7.0059 10.5L12.5 5.50302L2.88584 5.5Z"
											fill="#4D4D4D"
										/>
									</svg>
								)}
							</span>
						</div>
						{isDetailsOpen && (
							<p className="labels-caption details-caption grey-box">
								{translate(
									'This option will reduce the frequency of being asked to sign-in on this device. Use this option only on your trusted devices to keep your account secure.'
								)}
							</p>
						)}
						<div className="view__actions persistent-login-next">
							<Cta
								type="primary"
								disabled={OTP.length !== 6}
								onClick={() => handleSubmit(sendCodeTo, OTP, sendCodeVia, persistLogin)}
								className="button-filled"
							>
								{translate('Next')}
							</Cta>
						</div>
					</form>

					<footer className="view__footer persistent-login-footer">
						<Cta kind="link" onClick={() => resetFlow()}>
							{translate('I didn’t receive my code')}
						</Cta>
					</footer>
				</>
			) : (
				<>
					<h1 className="heading-2">{translate('Code Invalid')}</h1>
					<p className="intro body-2">
						{translate(
							'We’re sorry, but the verification code you entered is not valid. Please try again.'
						)}
					</p>
					<Cta type="primary" onClick={() => resetFlow()} className="button-filled">
						{translate('Get new code')}
					</Cta>
				</>
			)}
		</div>
	);
}
